var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { attrs: { id: "js-lineup__product--trigger" } }),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "js-lineup__product--pin" } },
      [
        _c(
          "div",
          {
            staticClass: "js-lineup__product",
            attrs: { "data-count-num": _vm.listSort.length },
          },
          [
            _c(
              "ul",
              { class: "lineup__product lineup__product--col" + _vm.colNum },
              _vm._l(_vm.listSort, function (item) {
                return _c("ListItem", { key: item.id, attrs: { item: item } })
              }),
              1
            ),
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.list, function (item) {
          return _c("ModalItem", { key: item.id, attrs: { item: item } })
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }